export type SupportedLocale = 'de' | 'fr' | 'en'

type LocalizedSuffix = 'De' | 'Fr' | 'En'

const localeSuffixMap: Record<SupportedLocale, LocalizedSuffix> = {
	de: 'De',
	fr: 'Fr',
	en: 'En',
}

/**
 * Returns the localized value for a trilingual field, falling back to German.
 *
 * @example
 * getLocalizedField(post, 'title', 'fr') // returns post.titleFr or post.titleDe
 */
export function getLocalizedField<
	T extends Record<string, unknown>,
	F extends string,
>(obj: T, field: F, locale: SupportedLocale): string {
	const suffix = localeSuffixMap[locale]
	const localizedKey = `${field}${suffix}` as keyof T
	const value = obj[localizedKey]

	if (typeof value === 'string' && value.length > 0) {
		return value
	}

	// Fall back to German
	const fallbackKey = `${field}De` as keyof T
	const fallback = obj[fallbackKey]
	return typeof fallback === 'string' ? fallback : ''
}
